import angular from 'angular';
import * as R from 'ramda';
import moment from 'moment';

export default function EditTestDocumentDialogController(
  $q,
  $scope,
  $rootScope,
  alerts,
  bcpDataService,
  ssDialogService
) {
  const vm = this;

  vm.isSaving = false;

  vm.newAttachment = angular.copy(vm.testDocument);
  vm.documentPresent = true;
  vm.isEdit = vm.newAttachment.assessmentTestDocumentId > 0;

  if (!R.isNil(vm.newAttachment.completedDate)) {
    vm.completedDate = moment(vm.newAttachment.completedDate);
  }

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleTestDocumentFileAdd = _handleTestDocumentFileAdd;
  vm.handleEditTestDocumentFormSubmit = _handleEditTestDocumentFormSubmit;

  _activate();

  function _activate() {
    if (vm.newAttachment.displayName) {
      vm.newAttachment.name = vm.newAttachment.displayName;
    }
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  // eslint-disable-next-line no-unused-vars
  function _handleTestDocumentFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.selectedFile = $file;
    vm.documentPresent = true;
    // console.log($files);
    // console.log($file);
    // console.log($newFiles);
    // console.log($duplicateFiles);
    // console.log($invalidFiles);
    // console.log($event);
  }

  function _handleEditTestDocumentFormSubmit() {
    // console.log(vm.test);
    if (_isValid()) {
      vm.isSaving = true;
      const assessmentTestId = vm.test.assessmentTestId;
      const assessmentTestDocumentId = vm.newAttachment.assessmentTestDocumentId;
      const displayName = vm.newAttachment.displayValue;
      let fileName = '';

      if (vm.selectedFile) {
        fileName = vm.selectedFile.name;
      }

      const promises = [
        bcpDataService.checkTestDocumentDisplayNameExists(assessmentTestId, assessmentTestDocumentId, displayName),
      ];

      if (fileName) {
        // eslint-disable-next-line max-len
        promises.push(bcpDataService.checkTestDocumentFileNameExists(assessmentTestId, assessmentTestDocumentId, fileName));
      }

      $q.all(promises).then((response) => {
        const displayNameExists = response[0].data.result;
        let fileNameExists = false;
        if (fileName) {
          // eslint-disable-next-line no-const-assign
          fileNameExists = response[1].data.result;
        }

        if (displayNameExists) {
          $scope.editTestDocumentForm.testDocumentName.$invalid = true;
          $scope.editTestDocumentForm.testDocumentName.$error = { duplicate: true };
          vm.isValid = false;
          // eslint-disable-next-line max-len
          alerts.error('There is currently a Test Document that uses the selected Name. Please choose a different Name.');
        } else {
          $scope.editTestDocumentForm.testDocumentName.$invalid = false;
          $scope.editTestDocumentForm.testDocumentName.$error = '';
        }

        if (fileNameExists) {
          vm.fileNameIsInvalid = true;
          vm.isValid = false;
          // eslint-disable-next-line max-len
          alerts.error('There is currently a Test Document that uses the same File Name. Please use a Document with a different File Name.');
        } else {
          vm.fileNameIsInvalid = false;
        }

        if ((!displayNameExists) && (!fileNameExists)) {
          const justEditMetadata = vm.isEdit && !vm.newAttachment.file;
          const dfdSave = $q.defer();

          if (justEditMetadata) {
            // Just editing metadata, no upload needed
            bcpDataService.updateTestDocument(vm.newAttachment).then(dfdSave.resolve);
          } else {
            // New file is supporting document
            bcpDataService.uploadTestDocument(vm.test.assessmentTestId, vm.newAttachment).then(dfdSave.resolve);
          }

          dfdSave.promise.then(() => {
            vm.isSaving = false;
            alerts.success('The Test Document has been saved successfully.');
            $rootScope.$broadcast('refreshBCPTestDocument');
            $rootScope.$broadcast('refreshBCPAssessments');
            _closeDialog();
          });
        } else {
          vm.isSaving = false;
        }
      });
    }
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editTestDocumentDialog);
  }

  function _isValid() {
    let isValid = true;

    if (vm.newAttachment.file || vm.newAttachment.assessmentTestDocumentId) {
      vm.documentPresent = true;
    } else {
      isValid = false;
      vm.documentPresent = false;
    }

    if ($scope.editTestDocumentForm.$invalid) {
      isValid = false;
    }

    return isValid;
  }
}

EditTestDocumentDialogController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'alerts',
  'bcpDataService',
  'ssDialogService'
];
